import { useState } from "react"

import { AiIcon } from "@/components/shared/icons/ai"
import { SideSheet } from "@/components/shared/ui/side-sheet"
import { AIChatPage } from "@/features/static/components/ai-chat"

export function AiFloatButton({
  code,
  shopName,
  otherUserId
}: {
  code?: string
  shopName?: string
  otherUserId?: string
}) {
  const [open, setOpen] = useState(false)
  return (
    <SideSheet
      open={open}
      setOpen={setOpen}
      trigger={<AiIcon />}
      children={
        <AIChatPage
          code={code}
          shopName={shopName}
          otherUserId={otherUserId}
          setOpen={() => setOpen(false)}
        />
      }
      side="right"
    />
  )
}
